package br.com.vvrefeicoes.portal.feature.rmp

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.Surface
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppBanner
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppPagination
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipText
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SearchableSelect
import br.com.vvrefeicoes.portal.core.ui.layout.AppHorizontalScrollbar
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.formatIsoDateTime
import br.com.vvrefeicoes.portal.domain.model.RmpLinkField
import br.com.vvrefeicoes.portal.domain.model.RmpPortalOption
import br.com.vvrefeicoes.portal.domain.model.RmpSyncCell
import br.com.vvrefeicoes.portal.domain.model.RmpSyncRecord
import br.com.vvrefeicoes.portal.domain.model.RmpSyncSituation
import br.com.vvrefeicoes.portal.domain.model.RmpSyncStatusFilter
import com.composables.icons.lucide.Building2
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.ChevronDown
import com.composables.icons.lucide.CircleAlert
import com.composables.icons.lucide.CircleCheck
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.User
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.rmp_retry
import portalvv.shared.generated.resources.rmp_sync_cancel_edit
import portalvv.shared.generated.resources.rmp_sync_col_actions
import portalvv.shared.generated.resources.rmp_sync_col_created_at
import portalvv.shared.generated.resources.rmp_sync_col_destination_director
import portalvv.shared.generated.resources.rmp_sync_col_destination_director_date
import portalvv.shared.generated.resources.rmp_sync_col_director
import portalvv.shared.generated.resources.rmp_sync_col_director_date
import portalvv.shared.generated.resources.rmp_sync_col_general_director
import portalvv.shared.generated.resources.rmp_sync_col_general_director_date
import portalvv.shared.generated.resources.rmp_sync_col_hr
import portalvv.shared.generated.resources.rmp_sync_col_hr_date
import portalvv.shared.generated.resources.rmp_sync_col_id
import portalvv.shared.generated.resources.rmp_sync_col_requester
import portalvv.shared.generated.resources.rmp_sync_col_status
import portalvv.shared.generated.resources.rmp_sync_col_type
import portalvv.shared.generated.resources.rmp_sync_col_unit
import portalvv.shared.generated.resources.rmp_sync_confirm_row
import portalvv.shared.generated.resources.rmp_sync_edit_row
import portalvv.shared.generated.resources.rmp_sync_empty
import portalvv.shared.generated.resources.rmp_sync_empty_adjusted
import portalvv.shared.generated.resources.rmp_sync_hint
import portalvv.shared.generated.resources.rmp_sync_no_suggestion
import portalvv.shared.generated.resources.rmp_sync_not_applicable
import portalvv.shared.generated.resources.rmp_sync_save_row
import portalvv.shared.generated.resources.rmp_sync_search
import portalvv.shared.generated.resources.rmp_sync_status_em_andamento
import portalvv.shared.generated.resources.rmp_sync_status_filter
import portalvv.shared.generated.resources.rmp_sync_status_finalizados
import portalvv.shared.generated.resources.rmp_sync_status_rejeitados
import portalvv.shared.generated.resources.rmp_sync_status_todos
import portalvv.shared.generated.resources.rmp_sync_subtitle
import portalvv.shared.generated.resources.rmp_sync_suggested_option
import portalvv.shared.generated.resources.rmp_sync_summary
import portalvv.shared.generated.resources.rmp_sync_tab_adjusted
import portalvv.shared.generated.resources.rmp_sync_tab_pending
import portalvv.shared.generated.resources.rmp_sync_title
import portalvv.shared.generated.resources.rmp_sync_unlinked
import portalvv.shared.generated.resources.rmp_type_all
import portalvv.shared.generated.resources.rmp_type_filter

// Mesmas colunas da listagem da RMP; a tabela rola na horizontal.
private val WidthId = 72.dp
private val WidthUnit = 240.dp
private val WidthType = 140.dp
private val WidthStatus = 110.dp
private val WidthPerson = 240.dp
private val WidthDate = 120.dp
private val WidthActions = 190.dp

private const val EMPTY_VALUE = "—"

@Composable
fun RmpSyncScreen() {
    val controller = rememberRmpSyncController()

    LaunchedEffect(controller) {
        controller.init()
    }

    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(Res.string.rmp_sync_title),
                style = MaterialTheme.typography.headlineMedium,
            )
            Text(
                text = stringResource(Res.string.rmp_sync_subtitle),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        controller.errorMessage?.let { message ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = MaterialTheme.colorScheme.errorContainer,
                shape = AppShapes.medium,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Text(
                        text = message,
                        color = MaterialTheme.colorScheme.onErrorContainer,
                        modifier = Modifier.weight(1f),
                    )
                    AppButton(
                        text = stringResource(Res.string.rmp_retry),
                        onClick = controller::retry,
                        variant = PortalButtonVariant.Outlined,
                    )
                }
            }
        }

        controller.feedback?.let { message ->
            AppBanner(text = message, onDismiss = controller::dismissFeedback, isError = true)
        }

        SituationTabs(controller)

        Toolbar(controller)

        controller.syncPage?.let { page ->
            Text(
                text = stringResource(Res.string.rmp_sync_summary, page.totalRmps, page.rmpsPending, page.cellsPending),
                style = MaterialTheme.typography.titleSmall,
            )
        }
        Text(
            text = stringResource(Res.string.rmp_sync_hint),
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )

        if (controller.loading) {
            Box(
                modifier = Modifier.fillMaxWidth().height(240.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        } else {
            SyncTable(controller)
            AppPagination(
                page = controller.page,
                pageCount = controller.pageCount,
                onPageChange = controller::goToPage,
                modifier = Modifier.align(Alignment.End),
            )
        }
    }
}

@Composable
private fun Toolbar(controller: RmpSyncController) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            StatusFilter(controller)
            TypeFilter(selected = controller.typeFilter, onSelect = controller::updateTypeFilter)
            AppTextField(
                value = controller.query,
                onValueChange = controller::updateQuery,
                placeholder = stringResource(Res.string.rmp_sync_search),
                leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                modifier = Modifier.width(320.dp),
            )
        }
    }
}

/** Pendentes × Ajustados; as contagens seguem o tipo filtrado, sem a busca. */
@Composable
private fun SituationTabs(controller: RmpSyncController) {
    val page = controller.syncPage
    val pending = page?.rmpsPending ?: 0
    val adjusted = page?.let { it.totalRmps - it.rmpsPending } ?: 0
    PrimaryScrollableTabRow(selectedTabIndex = controller.situation.ordinal) {
        RmpSyncSituation.entries.forEach { situation ->
            val label =
                when (situation) {
                    RmpSyncSituation.PENDENTES -> stringResource(Res.string.rmp_sync_tab_pending, pending)
                    RmpSyncSituation.AJUSTADOS -> stringResource(Res.string.rmp_sync_tab_adjusted, adjusted)
                }
            Tab(
                selected = situation == controller.situation,
                onClick = { controller.updateSituation(situation) },
                text = { Text(text = label) },
            )
        }
    }
}

@Composable
private fun StatusFilter(controller: RmpSyncController) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        AppButton(
            text = "${stringResource(Res.string.rmp_sync_status_filter)}: ${statusLabel(controller.statusFilter)}",
            onClick = { expanded = true },
            variant = PortalButtonVariant.Outlined,
            leadingIcon = Lucide.ChevronDown,
        )
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            RmpSyncStatusFilter.entries.forEach { filter ->
                DropdownMenuItem(
                    text = { Text(statusLabel(filter)) },
                    onClick = {
                        expanded = false
                        controller.updateStatusFilter(filter)
                    },
                )
            }
        }
    }
}

@Composable
private fun statusLabel(filter: RmpSyncStatusFilter): String =
    when (filter) {
        RmpSyncStatusFilter.FINALIZADOS -> stringResource(Res.string.rmp_sync_status_finalizados)
        RmpSyncStatusFilter.EM_ANDAMENTO -> stringResource(Res.string.rmp_sync_status_em_andamento)
        RmpSyncStatusFilter.REJEITADOS -> stringResource(Res.string.rmp_sync_status_rejeitados)
        RmpSyncStatusFilter.TODOS -> stringResource(Res.string.rmp_sync_status_todos)
    }

@Composable
private fun TypeFilter(
    selected: String?,
    onSelect: (String?) -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }
    val allLabel = stringResource(Res.string.rmp_type_all)
    Box {
        AppButton(
            text = "${stringResource(Res.string.rmp_type_filter)}: ${selected?.let { typeLabel(it) } ?: allLabel}",
            onClick = { expanded = true },
            variant = PortalButtonVariant.Outlined,
            leadingIcon = Lucide.ChevronDown,
        )
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            DropdownMenuItem(
                text = { Text(allLabel) },
                onClick = {
                    expanded = false
                    onSelect(null)
                },
            )
            RmpTypes.forEach { type ->
                DropdownMenuItem(
                    text = { Text(typeLabel(type)) },
                    onClick = {
                        expanded = false
                        onSelect(type)
                    },
                )
            }
        }
    }
}

@Composable
private fun SyncTable(controller: RmpSyncController) {
    val unitLabels = remember(controller.portalUnits) { optionLabels(controller.portalUnits) }
    val userLabels = remember(controller.portalUsers) { optionLabels(controller.portalUsers) }
    val records = controller.syncPage?.records.orEmpty()
    val scrollState = rememberScrollState()
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            // Barra em cima e embaixo: a tabela é alta, e assim dá para rolar para o lado sem descer até o fim.
            AppHorizontalScrollbar(
                state = scrollState,
                modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space8, vertical = AppSpacing.space4),
            )
            SyncTableContent(controller, records, unitLabels, userLabels, scrollState)
            AppHorizontalScrollbar(
                state = scrollState,
                modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space8, vertical = AppSpacing.space4),
            )
        }
    }
}

@Composable
private fun SyncTableContent(
    controller: RmpSyncController,
    records: List<RmpSyncRecord>,
    unitLabels: Map<String, String>,
    userLabels: Map<String, String>,
    scrollState: ScrollState,
) {
    Column(modifier = Modifier.horizontalScroll(scrollState)) {
        TableRow {
            HeaderCell(stringResource(Res.string.rmp_sync_col_id), WidthId)
            HeaderCell(stringResource(Res.string.rmp_sync_col_unit), WidthUnit)
            HeaderCell(stringResource(Res.string.rmp_sync_col_type), WidthType)
            HeaderCell(stringResource(Res.string.rmp_sync_col_status), WidthStatus)
            HeaderCell(stringResource(Res.string.rmp_sync_col_requester), WidthPerson)
            HeaderCell(stringResource(Res.string.rmp_sync_col_destination_director), WidthPerson)
            HeaderCell(stringResource(Res.string.rmp_sync_col_destination_director_date), WidthDate)
            HeaderCell(stringResource(Res.string.rmp_sync_col_director), WidthPerson)
            HeaderCell(stringResource(Res.string.rmp_sync_col_director_date), WidthDate)
            HeaderCell(stringResource(Res.string.rmp_sync_col_general_director), WidthPerson)
            HeaderCell(stringResource(Res.string.rmp_sync_col_general_director_date), WidthDate)
            HeaderCell(stringResource(Res.string.rmp_sync_col_hr), WidthPerson)
            HeaderCell(stringResource(Res.string.rmp_sync_col_hr_date), WidthDate)
            HeaderCell(stringResource(Res.string.rmp_sync_col_created_at), WidthDate)
            HeaderCell(stringResource(Res.string.rmp_sync_col_actions), WidthActions)
        }
        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant, modifier = Modifier.width(totalWidth()))
        if (records.isEmpty()) {
            Box(modifier = Modifier.width(totalWidth())) {
                val empty =
                    when (controller.situation) {
                        RmpSyncSituation.PENDENTES -> Res.string.rmp_sync_empty
                        RmpSyncSituation.AJUSTADOS -> Res.string.rmp_sync_empty_adjusted
                    }
                EmptyState(message = stringResource(empty))
            }
        } else {
            records.forEachIndexed { index, record ->
                RecordRow(record = record, unitLabels = unitLabels, userLabels = userLabels, controller = controller)
                if (index < records.lastIndex) {
                    HorizontalDivider(
                        color = MaterialTheme.colorScheme.outlineVariant,
                        modifier = Modifier.width(totalWidth()),
                    )
                }
            }
        }
    }
}

@Composable
private fun RecordRow(
    record: RmpSyncRecord,
    unitLabels: Map<String, String>,
    userLabels: Map<String, String>,
    controller: RmpSyncController,
) {
    val isTransfer = record.type == "transferencia"
    TableRow {
        TextCell("#${record.rmpId}", WidthId)
        LinkCell(record, record.unit, Lucide.Building2, unitLabels, controller, WidthUnit)
        TextCell(record.type?.let { typeLabel(it) }.orDash(), WidthType)
        TextCell(record.status.orDash(), WidthStatus)
        LinkCell(record, record.requester, Lucide.User, userLabels, controller, WidthPerson)
        if (isTransfer) {
            LinkCell(record, record.destinationDirector, Lucide.User, userLabels, controller, WidthPerson)
            TextCell(formatIsoDateTime(record.destinationDirector.date).orDash(), WidthDate)
        } else {
            TextCell(stringResource(Res.string.rmp_sync_not_applicable), WidthPerson)
            TextCell(stringResource(Res.string.rmp_sync_not_applicable), WidthDate)
        }
        LinkCell(record, record.director, Lucide.User, userLabels, controller, WidthPerson)
        TextCell(formatIsoDateTime(record.director.date).orDash(), WidthDate)
        LinkCell(record, record.generalDirector, Lucide.User, userLabels, controller, WidthPerson)
        TextCell(formatIsoDateTime(record.generalDirector.date).orDash(), WidthDate)
        LinkCell(record, record.hr, Lucide.User, userLabels, controller, WidthPerson)
        TextCell(formatIsoDateTime(record.hr.date).orDash(), WidthDate)
        TextCell(formatIsoDateTime(record.createdAt).orDash(), WidthDate)
        ConfirmRowCell(record, controller)
    }
}

/**
 * Coluna ajustável: o valor da RMP em cima e, embaixo, a situação (✓/⚠), o seletor do portal e a sugestão.
 * Sem valor na RMP, só o traço (nada a ajustar).
 */
@Composable
private fun LinkCell(
    record: RmpSyncRecord,
    cell: RmpSyncCell,
    icon: ImageVector,
    labels: Map<String, String>,
    controller: RmpSyncController,
    width: Dp,
) {
    if (!cell.applies) {
        TextCell(EMPTY_VALUE, width)
        return
    }
    // Na aba Ajustados a linha só muda depois do "Editar", e as trocas ficam no rascunho até o "Salvar".
    val adjustedTab = controller.situation == RmpSyncSituation.AJUSTADOS
    val editing = adjustedTab && controller.isEditing(record.id)
    val draft = controller.editDraft
    val selectedId = if (editing && cell.field in draft) draft[cell.field] else cell.targetId
    val pending = cell.applies && selectedId == null
    val enabled =
        when {
            editing -> !controller.isConfirming(record.id)
            adjustedTab -> false
            else -> !controller.isSaving(record.id, cell.field)
        }
    val onLink: (String?) -> Unit = { targetId ->
        if (editing) controller.updateDraft(record, cell.field, targetId) else controller.link(record.id, cell.field, targetId)
    }
    // Sem ajuste salvo, o seletor já mostra a opção mais próxima (sugestão), que só é gravada no "Confirmar linha".
    val suggestedId = if (cell.pending && !editing) cell.suggestedId else null
    Column(modifier = Modifier.width(width), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        AppTooltipText(
            text = cell.rmpName.orDash(),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            Icon(
                imageVector = if (pending) Lucide.CircleAlert else Lucide.CircleCheck,
                contentDescription = null,
                tint = if (pending) AppPalette.Error900 else MaterialTheme.colorScheme.primary,
                modifier = Modifier.size(16.dp),
            )
            LinkSelect(
                icon = icon,
                labels = labels,
                selectedId = selectedId,
                suggestedId = suggestedId,
                enabled = enabled,
                onSelect = onLink,
                modifier = Modifier.weight(1f),
            )
        }
    }
}

/**
 * Seletor da unidade/usuário do portal; a primeira opção remove o ajuste deste RMP. Sem ajuste salvo, exibe a
 * sugestão marcada como tal; escolher qualquer opção (inclusive a sugerida) grava na hora.
 */
@Composable
private fun LinkSelect(
    icon: ImageVector,
    labels: Map<String, String>,
    selectedId: String?,
    suggestedId: String?,
    enabled: Boolean,
    onSelect: (String?) -> Unit,
    modifier: Modifier = Modifier,
) {
    val unlinked = stringResource(Res.string.rmp_sync_unlinked)
    val options = remember(labels, unlinked) { listOf(unlinked) + labels.values }
    val idsByLabel = remember(labels) { labels.entries.associate { (id, label) -> label to id } }
    val suggestedLabel = suggestedId?.let { labels[it] }
    val selected =
        when {
            selectedId != null -> labels[selectedId] ?: unlinked
            suggestedLabel != null -> stringResource(Res.string.rmp_sync_suggested_option, suggestedLabel)
            else -> unlinked
        }
    SearchableSelect(
        leadingIcon = icon,
        options = options,
        selected = selected,
        onSelect = { label ->
            val id = idsByLabel[label]
            if (id != selectedId) onSelect(id)
        },
        enabled = enabled,
        underlined = true,
        contentColor =
            if (selectedId == null && suggestedLabel != null) {
                MaterialTheme.colorScheme.onSurfaceVariant
            } else {
                MaterialTheme.colorScheme.onSurface
            },
        modifier = modifier,
    )
}

/** "Confirmar linha": grava as sugestões pré-selecionadas das colunas ainda sem ajuste deste RMP. */
@Composable
private fun ConfirmRowCell(
    record: RmpSyncRecord,
    controller: RmpSyncController,
) {
    if (controller.situation == RmpSyncSituation.AJUSTADOS) {
        EditRowCell(record, controller)
        return
    }
    val pendingSuggestions = suggestionsToConfirm(record).size
    val pendingCells = record.cells().count { it.pending && (it.field != RmpLinkField.DIRETORA_DESTINO || record.type == "transferencia") }
    Box(modifier = Modifier.width(WidthActions)) {
        when {
            pendingSuggestions > 0 ->
                AppButton(
                    text = stringResource(Res.string.rmp_sync_confirm_row),
                    onClick = { controller.confirmRow(record) },
                    enabled = !controller.isConfirming(record.id),
                    variant = PortalButtonVariant.Filled,
                    leadingIcon = Lucide.Check,
                )
            // Pendente, mas sem nenhuma opção próxima no portal: o ajuste é manual, no seletor de cada coluna.
            pendingCells > 0 ->
                Text(
                    text = stringResource(Res.string.rmp_sync_no_suggestion),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
        }
    }
}

/** Aba Ajustados: "Editar" abre a linha para corrigir um ajuste errado; "Salvar" grava as colunas alteradas. */
@Composable
private fun EditRowCell(
    record: RmpSyncRecord,
    controller: RmpSyncController,
) {
    Box(modifier = Modifier.width(WidthActions)) {
        if (controller.isEditing(record.id)) {
            val busy = controller.isConfirming(record.id)
            Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                AppButton(
                    text = stringResource(Res.string.rmp_sync_save_row),
                    onClick = { controller.saveEdit(record) },
                    enabled = !busy,
                    variant = PortalButtonVariant.Filled,
                    leadingIcon = Lucide.Check,
                )
                AppButton(
                    text = stringResource(Res.string.rmp_sync_cancel_edit),
                    onClick = controller::cancelEdit,
                    enabled = !busy,
                    variant = PortalButtonVariant.Text,
                )
            }
        } else {
            AppButton(
                text = stringResource(Res.string.rmp_sync_edit_row),
                onClick = { controller.startEdit(record.id) },
                variant = PortalButtonVariant.Outlined,
                leadingIcon = Lucide.Pencil,
            )
        }
    }
}

@Composable
private fun TableRow(content: @Composable () -> Unit) {
    Row(
        modifier = Modifier.padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        content()
    }
}

@Composable
private fun HeaderCell(
    text: String,
    width: Dp,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.width(width),
    )
}

@Composable
private fun TextCell(
    text: String,
    width: Dp,
) {
    AppTooltipText(
        text = text,
        style = MaterialTheme.typography.bodyMedium,
        color = MaterialTheme.colorScheme.onSurface,
        modifier = Modifier.width(width),
    )
}

/** Largura total das colunas (para o estado vazio e os divisores ocuparem a tabela toda). */
private fun totalWidth(): Dp {
    val columns =
        listOf(WidthId, WidthUnit, WidthType, WidthStatus) + List(5) { WidthPerson } + List(5) { WidthDate } + WidthActions
    return columns.fold(0.dp) { sum, width -> sum + width } + AppSpacing.space12 * (columns.size - 1) + AppSpacing.space16 * 2
}

/**
 * Rótulo único por opção (id → rótulo): o seletor trabalha com texto, então nomes repetidos ganham o detalhe
 * (e-mail) ou, na falta dele, o início do id.
 */
internal fun optionLabels(options: List<RmpPortalOption>): Map<String, String> {
    val repeated =
        options
            .groupingBy { it.name.trim().lowercase() }
            .eachCount()
            .filterValues { it > 1 }
            .keys
    val labels = LinkedHashMap<String, String>()
    options.forEach { option ->
        val base = option.name.ifBlank { option.id }
        val needsDetail = option.detail != null || option.name.trim().lowercase() in repeated
        labels[option.id] =
            when {
                !needsDetail -> base
                option.detail != null -> "$base — ${option.detail}"
                else -> "$base (${option.id.take(8)})"
            }
    }
    return labels
}

private fun String?.orDash(): String = if (isNullOrBlank()) EMPTY_VALUE else this
